import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Form, Button, InputGroup, ButtonGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { isEmpty, lowerCase, startCase } from "lodash";
import { apiGet, apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import AuthContext from "../../context/AuthContext";
import PhoneInput from "react-phone-input-2";
import { useContextSelector } from "use-context-selector";
import iconBkash from "../../assets/images/bkash.png";
import iconRocket from "../../assets/images/rocket.png";
import iconNagad from "../../assets/images/nagad.png";
import iconEth from "../../assets/images/eth.svg";
import iconBtc from "../../assets/images/btc.svg";
import iconUpay from "../../assets/images/upay.png";
import bankImg from "../../assets/images/bank.png";
import { FaRegCopy } from "react-icons/fa";
import ConfirmPin from "../../component/ConfirmPin";
import { toFixedWithoutRounding, bankType } from "../../Utils/constants";
const Withdraw = () => {
  const navigate = useNavigate();
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const getProfileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.getProfileData;
  });
  const userCoins = useContextSelector(AuthContext, (ctx) => {
    return ctx.userCoins;
  });
  const amounutRefresh = useContextSelector(AuthContext, (ctx) => {
    return ctx.amounutRefresh;
  });
  const refreshAmountLoader = useContextSelector(AuthContext, (ctx) => {
    return ctx.refreshAmountLoader;
  });
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: { bankAccount: profileData?.phone },
    mode: "onChange",
    shouldFocusError: true,
  });
  let location = useLocation();
  const inputRef = useRef(null);
  const { t } = useTranslation();
  const [selectedMethod, setSelectedMethod] = useState("bkash");
  const [id, setId] = useState("");
  const [bank, setBank] = useState([]);
  const [confirmPin, setConfirmPin] = useState(false);
  const [pin, setPin] = useState("");
  const [minWithdraw, setMinWithdraw] = useState(200);
  const [maxWithdraw, setMaxWithdraw] = useState(30000);
  const [afterData, setAfterData] = useState({});
  const [verifyEdit, setVerifyEdit] = useState({});
  const [isLoader, setLoader] = useState(false);
  const [isLoader1, setLoader1] = useState(false);
  const {
    register: register1,
    handleSubmit: handleSubmit1,
    control: control1,
    formState: { errors: errors1 },
    reset: reset1,
  } = useForm({});

  const handleCloseVerify = () => {
    setVerifyEdit({ status: false });
  };
  const onSubmit = async (body) => {
    setConfirmPin(true);
    setAfterData(body);
  };

  const AfterPinSubmit = async (body) => {
    setLoader(true);
    let bodyObj = {
      amount: afterData?.amount,
      bank: id,
      AccountName: selectedMethod.toUpperCase(),
      BankAccount: afterData?.bankAccount,
      phone_number: afterData?.phone,
      pin: body?.verificationCode,
      payout: true,
    };

    const { status, data } = await apiPost(apiPath.withdrawal, bodyObj);
    if (status == 200) {
      if (data?.success) {
        toast.success(data?.message);
        amounutRefresh();
        reset();
        setAfterData({});
        setConfirmPin(false);
        setLoader(false);
      } else {
        toast.error(data?.message);
        reset();
        setAfterData({});
        setLoader(false);
        setConfirmPin(false);
      }
    } else {
      toast.error(data?.message);
      reset();
      setAfterData({});
      setLoader(false);
      setConfirmPin(false);
    }
  };

  const getBank = async () => {
    const { status, data } = await apiPost(apiPath.getBank, {
      type: "withdrawal",
    });
    if (status == 200) {
      if (data?.success) {
        setBank(
          data?.results?.bankList?.map((res) => {
            return { ...res, bank_name: lowerCase(res?.bank_name) };
          }),
        );
        if (data?.results?.bankList?.length > 0) {
          getBankDetail(data?.results?.bankList[0]?._id);
        }
      }
    }
  };
  const getBankDetail = async (body) => {
    setId(body);
    const { status, data } = await apiPost(apiPath.getBankDetail, {
      bank: body,
    });
    if (status == 200) {
      if (data?.success) {
        setValue("accountName", data?.results?.bankDetail?.account_name);
        setValue("bankAccount", data?.results?.bankDetail?.account_number);
      }
    }
  };
  const onSubmit1 = async (body) => {
    setLoader1(true);
    const { status, data } = await apiPost(apiPath.verifyOtpNew, {
      new_phone_number:
        inputRef?.current?.state.selectedCountry?.countryCode +
        body?.mobile?.substring(
          inputRef?.current?.state.selectedCountry?.countryCode?.length,
          body?.mobile?.toString()?.length,
        ),
      phone_number: profileData?.phone
        ? profileData?.phone
        : inputRef?.current?.state.selectedCountry?.countryCode +
          body?.mobile?.substring(
            inputRef?.current?.state.selectedCountry?.countryCode?.length,
            body?.mobile?.toString()?.length,
          ),
      type: "password",
      password: body?.verificationCode,
    });
    if (status === 200) {
      if (data.success) {
        setLoader1(false);
        handleCloseVerify();
        getProfileData();
        toast.success("Otp verified successfully");
        reset();
      } else {
        setLoader1(false);
        toast.error(data?.message);
      }
    } else {
      setLoader1(false);
      toast.error(data?.message);
    }
  };

  useEffect(() => {
    getBank();
    getProfileData();
  }, []);

  // useEffect(() => {
  //   if (!isEmpty(profileData) && profileData?.limitSetting.length > 0) {
  //     setMinWithdraw(
  //       profileData?.limitSetting.length > 0 &&
  //         profileData?.limitSetting[0]?.minWithdraw
  //     );
  //     setMaxWithdraw(
  //       profileData?.limitSetting.length > 0 &&
  //         profileData?.limitSetting[0]?.maxWithdraw
  //     );
  //   }
  // }, [!isEmpty(profileData?.limitSetting)]);

  const handleCopy = () => {
    if (!isEmpty(watch("bankAccount"))) {
      navigator.clipboard
        .writeText(watch("bankAccount"))
        .then(() => {
          toast.success("Copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    }
  };
  const sendMobileOTP = async (phone_number) => {
    if (phone_number) {
      const { status, data } = await apiPost(apiPath.userSendOtp, {
        phone_number: phone_number,
      });
      if (status === 200) {
        if (data.success) {
          toast.success("OTP sent succesfully");
        } else {
          toast.error(data?.message);
        }
      } else {
        toast.error(data?.message);
      }
    } else {
      toast.error("please enter correct mobile number");
    }
  };
  return (
    <div className="ng-tns-c613070388-13 ng-trigger ng-trigger-tabPageTriggerAni">
      <div className="tab-content tab-content-page ng-tns-c2278473435-17 ng-star-inserted">
        <div className="inner-wrap ng-tns-c2278473435-17">
          <div className="inner-box withdraw-wallet ng-tns-c2278473435-17 ng-star-inserted">
            <div className="player-top player-withdraw ng-tns-c2278473435-17">
              <div className="main-wallet-info ng-tns-c2278473435-17">
                <div className="operating-wallet ng-tns-c2278473435-17" />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  className="renew-main-wallet ng-tns-c2278473435-17"
                >
                  <span className="ng-tns-c2278473435-17">
                    {" "}
                    Total Wallet Balance{" "}
                  </span>
                  <span className="ng-tns-c2278473435-17">
                    BDT {userCoins?.totalCoins || 0}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  className="renew-main-wallet ng-tns-c2278473435-17"
                >
                  <span className="ng-tns-c2278473435-17">
                    {" "}
                    Withdrawable Amount{" "}
                  </span>
                  <span className="ng-tns-c2278473435-17">
                    BDT{" "}
                    {parseFloat(userCoins?.totalCoins).toFixed(2) -
                      parseFloat(profileData?.availableTurnoverFinal).toFixed(
                        2,
                      ) >
                    0
                      ? toFixedWithoutRounding(
                          parseFloat(userCoins?.totalCoins).toFixed(2) -
                            parseFloat(
                              profileData?.availableTurnoverFinal,
                            ).toFixed(2),
                        )
                      : 0}
                  </span>
                </div>{" "}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  className="renew-main-wallet ng-tns-c2278473435-17"
                >
                  <span className="ng-tns-c2278473435-17">
                    {" "}
                    Holding Amount{" "}
                  </span>
                  <span className="ng-tns-c2278473435-17">
                    BDT{" "}
                    {toFixedWithoutRounding(
                      profileData?.availableTurnoverFinal,
                    ) || 0}{" "}
                  </span>
                </div>
              </div>
            </div>
            <Form
              onSubmit={handleSubmit(onSubmit)}
              id="deposit_form"
              class="deposit_form"
            >
              <div
                _ngcontent-serverapp-c684031653
                className="menu-box ng-tns-c684031653-19"
              >
                <div
                  _ngcontent-serverapp-c684031653
                  className="title ng-tns-c684031653-19"
                >
                  <h2
                    _ngcontent-serverapp-c684031653
                    className="ng-tns-c684031653-19"
                  >
                    <span
                      style={{ width: "auto" }}
                      _ngcontent-serverapp-c684031653
                      className="ng-tns-c684031653-19"
                    >
                      {t("PaymentMethod")}
                    </span>
                  </h2>
                </div>
                {bankType?.length > 0 && (
                  <div
                    _ngcontent-serverapp-c684031653
                    className="check-group ng-tns-c684031653-19"
                  >
                    <ul className="col3">
                      {bankType.map((method) => (
                        <li key={method?._id} className="payment-option">
                          <input
                            type="radio"
                            id={method?._id}
                            name="paymentMethod"
                            checked={selectedMethod === method.bank_name}
                            onChange={() => {
                              setSelectedMethod(method.bank_name);
                              getBankDetail(method?._id);
                            }}
                          />
                          <label htmlFor={method?._id}>
                            <div className="payment-img">
                              <img
                                src={
                                  method?.bank_name
                                    .toLowerCase()
                                    .includes("bkash")
                                    ? iconBkash
                                    : method?.bank_name
                                          .toLowerCase()
                                          .includes("nagad")
                                      ? iconNagad
                                      : method?.bank_name
                                            .toLowerCase()
                                            .includes("rocket")
                                        ? iconRocket
                                        : method?.bank_name
                                              .toLowerCase()
                                              .includes("eth")
                                          ? iconEth
                                          : method?.bank_name
                                                .toLowerCase()
                                                .includes("btc")
                                            ? iconBtc
                                            : method?.bank_name
                                                  .toLowerCase()
                                                  .includes("upay")
                                              ? iconUpay
                                              : bankImg
                                }
                                loading="lazy"
                              />
                            </div>
                            <span>{startCase(method?.bank_name)}</span>
                          </label>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                <div
                  _ngcontent-serverapp-c684031653
                  className="check-group ng-tns-c684031653-19 ng-star-inserted"
                >
                  <ul
                    _ngcontent-serverapp-c684031653
                    className="col2 ng-tns-c684031653-19"
                  >
                    <app-basic-button
                      _ngcontent-serverapp-c684031653
                      radiogroupname="paymentType"
                      _nghost-serverapp-c4271250685
                      className="ng-tns-c684031653-19 ng-star-inserted"
                    >
                      <li
                        _ngcontent-serverapp-c4271250685
                        className="ng-star-inserted"
                      >
                        <input
                          _ngcontent-serverapp-c4271250685
                          type="radio"
                          name="paymentType"
                          id="paymentType_0"
                          checked
                        />
                        <label
                          _ngcontent-serverapp-c4271250685
                          htmlFor="paymentType_0"
                        >
                          <span _ngcontent-serverapp-c4271250685>
                            {startCase(selectedMethod)} Payment
                          </span>
                        </label>
                      </li>
                    </app-basic-button>
                  </ul>
                </div>
              </div>

              {!isEmpty(watch("accountName")) && (
                <>
                  <div
                    _ngcontent-serverapp-c684031653
                    className="ng-tns-c684031653-19 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c684031653
                      className="menu-box active ng-tns-c684031653-19 ng-star-inserted"
                    >
                      <div
                        _ngcontent-serverapp-c684031653
                        className="title ng-tns-c684031653-19"
                      >
                        <h2
                          _ngcontent-serverapp-c684031653
                          className="ng-tns-c684031653-19"
                        >
                          <span
                            style={{ width: "auto" }}
                            _ngcontent-serverapp-c684031653
                            className="ng-tns-c684031653-19"
                          >
                            {t("Account_Name")}
                          </span>
                        </h2>
                      </div>

                      <div
                        _ngcontent-serverapp-c684031653
                        className="input-group money ng-tns-c684031653-19"
                      >
                        <input
                          _ngcontent-serverapp-c684031653
                          className="ng-tns-c684031653-19 ng-untouched ng-pristine ng-valid"
                          type="text"
                          disabled
                          {...register("accountName")}
                        />
                      </div>
                    </div>
                  </div>{" "}
                  <div
                    _ngcontent-serverapp-c684031653
                    className="ng-tns-c684031653-19 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c684031653
                      className="menu-box active ng-tns-c684031653-19 ng-star-inserted"
                    >
                      <div
                        _ngcontent-serverapp-c684031653
                        className="title ng-tns-c684031653-19"
                      >
                        <h2
                          _ngcontent-serverapp-c684031653
                          className="ng-tns-c684031653-19"
                        >
                          <span
                            style={{ width: "auto" }}
                            _ngcontent-serverapp-c684031653
                            className="ng-tns-c684031653-19"
                          >
                            {t("Bank_Account")}
                          </span>
                        </h2>
                      </div>

                      <div
                        _ngcontent-serverapp-c684031653
                        className="input-group money ng-tns-c684031653-19"
                      >
                        {" "}
                        <FaRegCopy
                          onClick={() => handleCopy()}
                          color="white"
                          size={20}
                          style={{
                            position: "absolute",
                            left: "10px",
                          }}
                        />
                        <input
                          _ngcontent-serverapp-c684031653
                          className="ng-tns-c684031653-19 ng-untouched ng-pristine ng-valid"
                          type="text"
                          disabled
                          {...register("bankAccount")}
                        />
                      </div>
                    </div>
                  </div>{" "}
                </>
              )}
              <div className="menu-box ng-tns-c2278473435-17">
                <div className="title ng-tns-c2278473435-17">
                  <h2 className="ng-tns-c2278473435-17">
                    <span
                      style={{ textAlign: "left" }}
                      className="ng-tns-c2278473435-17"
                    >
                      {" "}
                      {t("Amount")}{" "}
                    </span>
                  </h2>
                </div>

                <div
                  _ngcontent-serverapp-c684031653
                  className="input-group money ng-tns-c684031653-19"
                >
                  <input
                    {...register("amount", {
                      required: {
                        value: true,
                        message: t("Please_enter_amount"),
                      },
                      validate: (value) => {
                        if (value > 0) {
                          if (Number(value) > Number(maxWithdraw)) {
                            return (
                              "Amount should not be greater than " + maxWithdraw
                            );
                          } else if (value < Number(minWithdraw)) {
                            return (
                              "Minimum Amount Should be greater than " +
                              minWithdraw
                            );
                          }
                        } else {
                          return t("Amount_0");
                        }
                      },
                    })}
                    type="number"
                    class="text-input"
                    id="depositAmt"
                    placeholder="0.00"
                  />
                </div>

                {errors.amount && errors.amount.message && (
                  <div
                    _ngcontent-serverapp-c3110418782
                    className="error-message-box ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c3110418782
                      className="error-message"
                    >
                      <span _ngcontent-serverapp-c3110418782>
                        {errors.amount.message}
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <div
                _ngcontent-serverapp-c684031653
                className="option-group select-bar ng-tns-c684031653-19"
              >
                <h2
                  style={{ width: "auto" }}
                  _ngcontent-serverapp-c684031653
                  className="ng-tns-c684031653-19"
                >
                  {t("Mobile_Number")}
                </h2>
                <div
                  _ngcontent-serverapp-c684031653
                  className="option-wrap ng-tns-c684031653-19"
                >
                  <select
                    {...register("phone", {
                      required: {
                        value: true,
                        message: "Select number",
                      },
                    })}
                    id="depositBankId"
                    className="ng-tns-c684031653-19 ng-untouched ng-pristine ng-valid"
                    onChange={(e) => {
                      setValue("bankAccount", e.target.value);
                    }}
                  >
                    <option value="">{t("Select_number")}</option>

                    <option value={profileData?.phone}>
                      {profileData?.phone}
                    </option>

                    {profileData?.temporaryPhone &&
                      profileData?.temporaryPhone != 0 && (
                        <option value={profileData?.temporaryPhone}>
                          {profileData?.temporaryPhone}
                        </option>
                      )}
                  </select>

                  {errors?.phone?.message && (
                    <div
                      _ngcontent-serverapp-c3110418782
                      className="error-message-box ng-star-inserted"
                    >
                      <div
                        _ngcontent-serverapp-c3110418782
                        className="error-message"
                      >
                        <span _ngcontent-serverapp-c3110418782>
                          {errors?.phone?.message}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* {!(profileData?.temporaryPhone > 0 && profileData?.phone > 0) && ( */}
                {/* <div
                  style={{ paddingLeft: "10px" }}
                  onClick={() => navigate("/profile")}
                  _ngcontent-serverapp-c8985285
                  className="input-group personal-phone-group ng-tns-c8985285-27"
                >
                  <label
                    _ngcontent-serverapp-c8985285
                    htmlFor="other"
                    className="ng-tns-c8985285-27"
                  >
                    <div
                      _ngcontent-serverapp-c8985285
                      className="add-btn ng-tns-c8985285-27"
                    >
                      <div
                        _ngcontent-serverapp-c8985285
                        className="add-btn-icon ng-tns-c8985285-27"
                      />
                      <span
                        _ngcontent-serverapp-c8985285
                        className="ng-tns-c8985285-27"
                      >
                        Add Mobile
                      </span>
                    </div>
                  </label>
                </div> */}
              {/* )} */}

              <div
                _ngcontent-serverapp-c684031653
                className="member-content ng-tns-c684031653-19 ng-star-inserted"
              >
                <div
                  _ngcontent-serverapp-c684031653
                  className="button btn-primary ng-tns-c684031653-19"
                >
                  <button
                    type="submit"
                    className="ng-tns-c684031653-19"
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      width: "100%",
                      height: "100%",
                      color: "white",
                      fontWeight: "600",
                      fontSize: "20px",
                    }}
                  >
                    {t("WITHDRAW")}
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>

      {verifyEdit?.status && (
        <app-profile-verified-inner
          _ngcontent-serverapp-c8985285=""
          _nghost-serverapp-c421677202=""
          class="ng-tns-c8985285-16 ng-tns-c421677202-17 ng-star-inserted"
        >
          <div
            _ngcontent-serverapp-c421677202=""
            className="pop-get-vcode ng-tns-c421677202-17 ng-trigger ng-trigger-popWrapTriggerAni active ng-star-inserted"
          >
            <a
              onClick={() => handleCloseVerify()}
              _ngcontent-serverapp-c421677202=""
              className="btn-closed ng-tns-c421677202-17"
              style={{
                maskImage:
                  'url("https://img.s303ix6.com/s6/h5/assets/images/icon-set/base/icon-close.svg?v=1760442828735")',
              }}
            />
            <Form
              onSubmit={handleSubmit1(onSubmit1)}
              _ngcontent-serverapp-c421677202=""
              className="ng-tns-c421677202-17 ng-untouched ng-pristine ng-invalid"
            >
              <div
                _ngcontent-serverapp-c421677202=""
                className="menu-box ng-tns-c421677202-17"
              >
                <div
                  _ngcontent-serverapp-c421677202=""
                  className="input-group ng-tns-c421677202-17"
                >
                  <label
                    _ngcontent-serverapp-c421677202=""
                    className="ng-tns-c421677202-17 ng-star-inserted"
                    htmlFor="other"
                  >
                    {" "}
                    New Phone Number{" "}
                  </label>
                  <div
                    _ngcontent-serverapp-c421677202=""
                    className="input-wrap ng-tns-c421677202-17 ng-star-inserted"
                  >
                    {verifyEdit?.phoneStatus == "add" && (
                      <Controller
                        control={control1}
                        name="mobile"
                        rules={{
                          required: "Enter Mobile Number",
                          validate: (value) => {
                            let inputValue = value
                              ?.toString()
                              ?.slice(
                                inputRef?.current?.state?.selectedCountry
                                  ?.countryCode?.length,
                                value?.length,
                              );
                            if (inputValue?.length < 10) {
                              return "Min length must be more than 10 digit";
                            } else if (inputValue?.length > 12) {
                              return "Max length must be 12 digit";
                            } else {
                              return true;
                            }
                          },
                        }}
                        render={({ field: { ref, ...field } }) => (
                          <>
                            <PhoneInput
                              {...field}
                              inputExtraProps={{
                                ref,
                                required: true,
                                autoFocus: true,
                              }}
                              ref={inputRef}
                              className="inputrefNew"
                              country={"bd"}
                            />
                          </>
                        )}
                      />
                    )}
                    {errors1.mobile && errors1.mobile.message && (
                      <div
                        _ngcontent-serverapp-c3110418782
                        className="error-message-box ng-star-inserted"
                      >
                        <div
                          _ngcontent-serverapp-c3110418782
                          className="error-message"
                        >
                          <span _ngcontent-serverapp-c3110418782>
                            {errors1.mobile.message}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* <div
                    onClick={() =>
                      sendMobileOTP(
                        profileData?.phone && profileData?.phone != "0"
                          ? profileData?.phone
                          : inputRef?.current?.state?.formattedNumber
                              .replace(/\s/g, "")
                              .replace(/\+/g, "")
                      )
                    }
                    _ngcontent-serverapp-c8985285
                    className="input-group personal-phone-group ng-tns-c8985285-27"
                  >
                    <label
                      _ngcontent-serverapp-c8985285
                      htmlFor="other"
                      className="ng-tns-c8985285-27"
                    >
                      <div
                        _ngcontent-serverapp-c8985285
                        className="add-btn ng-tns-c8985285-27"
                      >
                        <span
                          style={{ padding: "5px" }}
                          _ngcontent-serverapp-c8985285
                          className="ng-tns-c8985285-27"
                        >
                          Send Otp
                        </span>
                      </div>
                    </label>
                  </div> */}
                </div>{" "}
                <div
                  _ngcontent-serverapp-c684031653
                  className="title ng-tns-c684031653-19"
                >
                  <h2
                    _ngcontent-serverapp-c684031653
                    className="ng-tns-c684031653-19"
                  >
                    <span
                      style={{ width: "auto" }}
                      _ngcontent-serverapp-c684031653
                      className="ng-tns-c684031653-19"
                    >
                      Password
                    </span>
                  </h2>
                </div>
                <div
                  _ngcontent-serverapp-c684031653
                  className="input-group money ng-tns-c684031653-19"
                >
                  <input
                    _ngcontent-serverapp-c684031653
                    className="ng-tns-c684031653-19 ng-untouched ng-pristine ng-valid"
                    type="text"
                    placeholder="Enter password"
                    {...register1("verificationCode", {
                      required: "Please enter password",
                    })}
                  />
                  {errors1.verificationCode &&
                    errors1.verificationCode.message && (
                      <div
                        _ngcontent-serverapp-c3110418782
                        className="error-message-box ng-star-inserted"
                      >
                        <div
                          _ngcontent-serverapp-c3110418782
                          className="error-message"
                        >
                          <span _ngcontent-serverapp-c3110418782>
                            {errors1.verificationCode.message}
                          </span>
                        </div>
                      </div>
                    )}
                </div>
                <div
                  _ngcontent-serverapp-c684031653
                  className="member-content ng-tns-c684031653-19 ng-star-inserted"
                >
                  <div
                    _ngcontent-serverapp-c684031653
                    className="button btn-primary ng-tns-c684031653-19"
                    style={{ marginLeft: "0", marginRight: "0", width: "100%" }}
                  >
                    <button
                      type="submit"
                      className="ng-tns-c684031653-19"
                      style={{
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        width: "100%",
                        height: "100%",
                        color: "white",
                        fontWeight: "600",
                        fontSize: "20px",
                      }}
                    >
                      {t("Submit")}
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
          <div
            _ngcontent-serverapp-c421677202=""
            className="pop-bg ng-tns-c421677202-17 ng-trigger ng-trigger-popBgTriggerAni ng-star-inserted"
            style={{
              display: "block",
            }}
          />
        </app-profile-verified-inner>
      )}
      {confirmPin && !isEmpty(afterData) && (
        <ConfirmPin
          isLoader={isLoader}
          show={confirmPin}
          handelClose={() => setConfirmPin(false)}
          pin={pin}
          setPin={setPin}
          onSubmit={AfterPinSubmit}
        />
      )}
    </div>
  );
};

export default Withdraw;
